import React from 'react'
import './Gallery.css'
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';
import { EffectCoverflow, Pagination } from 'swiper/modules';
import { Link } from 'react-router-dom';

const galleryList = [
    { name: "gallery1.jpeg", title: "CarGenie" },
    { name: "gallery2.jpeg", title: "CarGenie" },
    { name: "gallery3.jpeg", title: "CarGenie" },
    { name: "gallery4.jpeg", title: "CarGenie" },
    { name: "gallery5.jpeg", title: "CarGenie" },
    { name: "gallery6.jpeg", title: "CarGenie" },
    { name: "gallery7.jpeg", title: "CarGenie" },
    { name: "gallery8.jpeg", title: "CarGenie" },
    { name: "gallery9.jpeg", title: "CarGenie" },
    { name: "gallery10.jpeg", title: "CarGenie" },
    { name: "gallery11.jpeg", title: "CarGenie" },
    { name: "gallery12.jpeg", title: "CarGenie" },
    { name: "gallery13.jpeg", title: "CarGenie" },
    { name: "gallery14.jpeg", title: "CarGenie" },
    { name: "gallery15.jpeg", title: "CarGenie" },
    { name: "gallery16.jpeg", title: "CarGenie" },
    { name: "gallery17.jpeg", title: "CarGenie" },
    { name: "gallery18.jpeg", title: "CarGenie" },
]

const Gallery = React.forwardRef((props, ref) => {
    
    return (
        <>
            <div className='galleryCont' ref={ref}>
                <h1> Gallery </h1>
                <Swiper
                    effect={'coverflow'}
                    grabCursor={true}
                    centeredSlides={true}
                    slidesPerView={'auto'}
                    coverflowEffect={{
                        rotate: 50,
                        stretch: 0,
                        depth: 100,
                        modifier: 1,
                        slideShadows: true,
                    }}
                    loop={true}
                    pagination={true}
                    modules={[EffectCoverflow, Pagination]}
                    className="mySwiper"
                >
                    {galleryList.map((items) => (
                        <SwiperSlide><img src={`images/${items.name}`} alt='carGenie' title={items.title} /></SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </>
    )
})

export default Gallery